module.exports = __webpack_public_path__ + "img/about-values-02.jpg?fa05996be22cdd7112e3d8001f7c4310";